module.exports = __webpack_public_path__ + "img/menucn-5-3.07532f7d.svg";